    import React, { useEffect, useState } from 'react';
    import { Box, Autocomplete, TextField, Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
    import CloseIcon from "@mui/icons-material/Close";
    import ListofExams from '../../../Manager/list-of-exams/ListofExams';
    import axios from 'axios';
    import './ExamSelector.css';

    const ExamSelector = ({
        selectedExam,
        setSelectedExam,
        setSelectedExamId,
        setSelectedExamDuration,
        isEdit,
        isMobile
    }) => {

        const [openLookup, setOpenLookup] = useState(false);
        const [localExams, setLocalExams] = useState([]);
        const [error, setError] = useState('');

        // Fetch exams from API when component mounts
        useEffect(() => {
            const fetchAllExams = async () => {
                try {
                    const res = await axios.get(`/coordinators/all-exams/`);
                    setLocalExams(res.data || []);
                } catch (err) {
                    setError("Failed to fetch assessments. Please try again later.");
                    console.error("Error fetching exams:", err);
                }
            };

            fetchAllExams();
        }, []);

        const handleExamSelect = (exam) => {
        // Format for display exactly like dropdown
        const displayTitle = `${exam.Title} - ${exam.ExamNumber} (${exam.ExamType})`;

        setSelectedExam(displayTitle);        // display in the input/dropdown
        setSelectedExamId(exam.Id);           // store the ID
        setSelectedExamDuration(exam.Duration || null); // optional: store duration

        // Add to localExams if not already present
        const exists = localExams.some(e => e.Id === exam.Id);
        if (!exists) {
            setLocalExams(prev => [...prev, exam]);
        }

        setOpenLookup(false); // close the lookup dialog
    };

        // Find the currently selected exam object
        const selectedExamObject = localExams.find(exam => exam.Title === selectedExam) || null;

        return (
            <Box>
                <label className="date-label">
                    Select Assessment<span className="required-asterisk">*</span>
                </label>

                <Box sx={{ display: 'flex', alignItems: 'stretch', gap: 1, width: '100%' }}>
                    {!isEdit && (
                        <Autocomplete
                            options={localExams}
                            getOptionLabel={(option) => option?.Title || ""}
                            value={selectedExamObject}
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    setSelectedExam(newValue.Title);
                                    setSelectedExamId(newValue.Id);
                                    setSelectedExamDuration(null);
                                }
                            }}
                            disableClearable
                            sx={{ flex: 1, width: '100%' }}
                            filterOptions={(options, { inputValue }) =>
                                options.filter(option =>
                                    option?.Title?.toLowerCase().includes(inputValue.toLowerCase())
                                )
                            }
                            isOptionEqualToValue={(option, value) => option?.Id === value?.Id}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    required
                                    fullWidth
                                    placeholder="Select Assessment"
                                    variant="outlined"
                                    InputProps={{ ...params.InputProps, className: 'form-control', style: { padding: '4px 10px', height: '55px', fontSize: '0.875rem', borderRadius: '7px' } }}
                                />
                            )}
                        />
                    )}

                    {isEdit && (
                        <input value={selectedExam} disabled className="form-control" style={{ flex: 1 }} />
                    )}

                    <img
                        style={{ width: isMobile ? '36px' : '45px', height: '55px', cursor: 'pointer' }}
                        src="/images/lookupIcon.png"
                        alt="Lookup"
                        onClick={() => setOpenLookup(true)}
                    />
                </Box>

                {error && <p style={{ color: 'red' }}>{error}</p>}

                <Dialog open={openLookup} onClose={() => setOpenLookup(false)} maxWidth="lg" fullWidth>
                    <DialogTitle>
                        Select Assessment
                        <IconButton onClick={() => setOpenLookup(false)} sx={{ position: "absolute", right: 8, top: 8 }}>
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent dividers>
                        <ListofExams isLookup={true} onSelectExam={handleExamSelect} apiUrl="/coordinators/get-exams/"  />
                    </DialogContent>
                </Dialog>
            </Box>
        );
    };

    export default ExamSelector;
